import PropTypes from 'prop-types';

import './styles/index.css';

const AccountAssocView = ({ userAccAssocLabels, regionAccount }) => {
  const { soldTos = [] } = regionAccount;
  const selectedSoldTos = soldTos.filter(s => s.selected);
  let shipTos = [];
  let bzUnit = [];
  let ships = {};

  return (
    <>
      {selectedSoldTos.map(soldTo => {
        if (soldTo.shipTos.length) {
          shipTos = [...soldTo.shipTos];
          ships = shipTos.filter(p => p.selected);
          return ships.map(shipObj => {
            if (shipObj.salesArea.length) {
              bzUnit = [...shipObj.salesArea];
              bzUnit = bzUnit.filter(opt => opt.selected);
              return bzUnit.map(bz => (
                <div className="account-row" key={soldTo.value}>
                  <div className="column-wrap">
                    <div className="eta b title">{userAccAssocLabels.soldTo}</div>
                    <div className="zeta b value">{soldTo.value}</div>
                    <div className="zeta b label">{soldTo.label}</div>
                  </div>
                  <div className="column-wrap">
                    <div className="eta b title">{userAccAssocLabels.shipTo}</div>
                    <div className="zeta b value">{shipObj && shipObj.value}</div>
                    <div className="zeta b label">{shipObj && shipObj.label}</div>
                  </div>
                  <div className="column-wrap">
                    <div className="eta b title">{userAccAssocLabels.businessUnit}</div>
                    <div className="zeta b value">{bz && bz.label}</div>
                  </div>
                </div>
              ));
            }
            return [];
          });
        }
        return [];
      })}
    </>
  );
};

AccountAssocView.propTypes = {
  userAccAssocLabels: PropTypes.instanceOf(Object).isRequired,
  regionAccount: PropTypes.instanceOf(Object)
};

AccountAssocView.defaultProps = {
  regionAccount: {}
};

export default AccountAssocView;
